import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FnDateConfig } from '../date-picker';
import { FnLocalStorageService } from '../../services/fn-local-storage.service';
import { hwAny } from '../../util/types';
import { FnUtilService } from '../../services/fn-util.service';

@Component({
  selector: 'fn-date-event-filter',
  templateUrl: './fn-date-event-filter.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FnDateEventFilterComponent extends FnLocalStorageService implements OnInit {

  filterOptionArray: Array<OptionKey>;

  private clonedFilterArray: Array<hwAny>;

  @Input() selectedDate: Date;

  @Input() currentDate = new Date();

  @Input() dateConfig: FnDateConfig

  @Input() dateRangeConfig: FNDateRangeConfig;

  @Input() selectedOption: hwAny;

  @Output() callback: hwAny = new EventEmitter();

  @Output() nextPrevDateCallback: hwAny = new EventEmitter();

  isRangeLoadingDone: boolean = false;

  uiMap: hwAny = {
    selectedOption: 'TODAY',
    selectedKey: 'Today',
  }

  /**
   * Creates an instance of fn event filter component.
   * @param elemRef ElementRef ref
   */
  constructor(private elemRef: ElementRef, private utilSvcs: FnUtilService) {
    super();
  }

  uiEventFilterMap = {
    isClearDisabled: true,
    isApplyDisabled: true,
    isFilterApply: false,
    isOpenDropDown: false,
    fnBtnClass: 'btn-sm btn-round btn-outline-secondary dropdown-toggle dateFilterBtn',
    fnBtnIconClass: 'global-expand'
  };

  ngOnInit(): void {
    this.setDefaultData();
  }

  private setDefaultData() {
    this.selectedDate = this.getDate(0);
    this.filterOptionArray = [{ 'id': 'TODAY', 'desc': 'Today' },
    { 'id': 'TODAY_LAST_WEEK', 'desc': 'This Day Last Week' },
    { 'id': 'YESTERDAY', 'desc': 'Yesterday' },
    { 'id': 'THIS_DAY_LAST_YEAR', 'desc': 'This Day Last Year' },
    { 'id': 'THIS_DAY_LAST_MONTH', 'desc': 'This Day Last Month' },
    { 'id': 'THIS_MONTH', 'desc': 'This Month' },
    { 'id': 'THIS_YEAR', 'desc': 'This Year' },
    { 'id': 'LAST_MONTH', 'desc': 'Last Month' },
    { 'id': 'RANGE', 'desc': 'Range' },
    { 'id': 'THIS_WEEK', 'desc': 'This Week' },
    { 'id': 'LAST_WEEK', 'desc': 'Last Week' },
    { 'id': 'CUSTOM', 'desc': 'Custom' }]
    this.toBeShownOptions();
    this.uiMap.selectedOption = this.selectedOption ? this.selectedOption : this.uiMap.selectedOption
    this.setDefaultFilterState();
  }

  private setDefaultFilterState() {
    let filterState: DateFilterState = this.getItem('dateFilterState');
    if (!this.utilSvcs.isEmptyObject(filterState) && this.dateRangeConfig.toBeShowen.indexOf(filterState.id) != -1) {
      switch (filterState.id) {
        case 'RANGE':
          this.dateRangeConfig.startDate = new Date(filterState.startDate);
          this.dateRangeConfig.endDate = new Date(filterState.endDate);
          this.selectedDate = this.currentDate;
          break;
        case 'CUSTOM':
          this.selectedDate = new Date(filterState.startDate);
          this.dateRangeConfig.startDate = this.currentDate;
          this.dateRangeConfig.endDate = this.currentDate;
          break;
        default:
          this.dateRangeConfig.startDate = this.currentDate;
          this.dateRangeConfig.endDate = this.currentDate;
          this.selectedDate = this.currentDate;
          break;
      }
      this.uiMap.selectedOption = filterState.id;
      this.filterOptionArray.forEach(element => {
        if (element.id === this.uiMap.selectedOption) {
          this.uiMap.selectedKey = element.desc;
        }
      })
    } else {
      filterState = {
        startDate: this.currentDate,
        endDate: this.currentDate,
        id: 'TODAY'
      }
      this.setItem('dateFilterState', filterState);
    }

    if (filterState.id === 'CUSTOM') {
      this.selectedDateFilter(this.selectedDate, this.selectedDate);
    } else if (filterState.id === 'RANGE') {
      this.selectedDateFilter(this.dateRangeConfig.startDate, this.dateRangeConfig.endDate);
    } else {
      this.applyFilter();
    }
  }


  setDateFilterState(startDate: hwAny, endDate: hwAny) {
    var newFilterState = {
      startDate: startDate,
      endDate: startDate,
      id: this.selectedOption != undefined ? this.selectedOption : 'TODAY'
    }
    this.setItem('dateFilterState', newFilterState);

  }

  toBeShownOptions() {
    this.filterOptionArray = this.filterOptionArray.filter((e: hwAny) => this.dateRangeConfig.toBeShowen.indexOf(e.id) !== -1)
  }

  /**
  * Method to Apply  Rest Event Filter|| filterState.id === 'CUSTOM'
  * @param isFilterApply boolean value if true then filter applied
  */
  resetFilter() {
    this.uiEventFilterMap.isClearDisabled = true;
    this.uiEventFilterMap.isFilterApply = true;
    this.uiEventFilterMap.isOpenDropDown = true;
    this.showOrHideDropDown(false, false);
    this.uiMap.selectedOption = 'TODAY';
    this.uiMap.selectedKey = 'Today'
    this.selectedDate = this.getDate(0);
    this.applyFilter();
  }

  showOrHideDropDown(isToOpen: boolean, isToRestFilter?: boolean) {
    this.uiEventFilterMap.isApplyDisabled = true;
    this.uiEventFilterMap.isOpenDropDown = isToOpen;
    if (!isToOpen && isToRestFilter) {
      this.filterOptionArray = this.clonedFilterArray;
    } else if (isToOpen) {
      this.clonedFilterArray = this.utilSvcs.copyObject(this.filterOptionArray);
    }
  }

  /**
   * Hosts listener to cose dropdown when user click outside Filter Component
   * @param event Event ref to check user click outside Filter Component
   */
  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (!this.elemRef.nativeElement.contains(event.target) && this.uiEventFilterMap.isOpenDropDown) {
      this.showOrHideDropDown(false, true);
      event.stopPropagation();
    }
  }


  applyFilter() {
    switch (this.uiMap.selectedOption) {
      case 'TODAY':
        this.selectedDateFilter(this.getDate(0), this.getDate(0));
        break;
      case 'YESTERDAY':
        this.selectedDateFilter(this.getDate(-1), this.getDate(-1));
        break;
      case 'TODAY_LAST_WEEK':
        this.selectedDateFilter(this.getDate(-7), this.getDate(-7));
        break;
      case 'THIS_DAY_LAST_YEAR':
        this.selectedDateFilter(this.getPrevYear(this.getDate(0)), this.getPrevYear(this.getDate(0)));
        break;
      case 'THIS_DAY_LAST_MONTH':
        this.selectedDateFilter(this.getPrevMonthThisDate(), this.getPrevMonthThisDate());
        break;
      case 'THIS_MONTH':
        this.selectedDateFilter(this.getNextPrevMonth(0, 1), this.getNextPrevMonth(1, 0))
        break;
      case 'LAST_MONTH':
        this.selectedDateFilter(this.getNextPrevMonth(-1, 1), this.getNextPrevMonth(0, 0))
        break;
      case 'THIS_YEAR':
        this.selectedDateFilter(this.getFirstDayOfYear(), new Date());
        break;
      case 'THIS_WEEK':
        this.selectedDateFilter(this.getFirstDayOfWeek(0), this.getLastDayOfWeek(0));
        break;
      case 'LAST_WEEK':
        this.selectedDateFilter(this.getFirstDayOfWeek(-1), this.getLastDayOfWeek(-1));
        break;
      case 'CUSTOM':
        this.selectedDateFilter(this.getDate(0), this.getDate(0));
        break;
      case 'RANGE':
        this.dateRangeConfig.startDate = this.getDate(0);
        this.dateRangeConfig.endDate = this.getDate(0);
        this.selectedDateFilter(this.getDate(0), this.getDate(0));
        break;
    }
  }


  selectedDateFilter(startDate: Date, endDate: Date) {
    this.isRangeLoadingDone = this.uiMap.selectedOption === 'RANGE' ? true : false;
    this.selectedDate = startDate;
    this.showOrHideDropDown(false, false);
    this.setDateFilterState(startDate, endDate)
    this.callback.emit({
      startDate: startDate,
      endDate: endDate,
      key: this.uiMap.selectedOption
    });
  }

  getDate(offset: number) {
    return new Date(this.currentDate).dateOffset(offset);
  }

  getNextPrevMonth(offset: number, lastMonth: number) {
    return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + offset, lastMonth);
  }

  getPrevMonthThisDate() {
    return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, this.currentDate.getDate());
  }

  getPrevYear(selectedDate: Date) {
    console.log(selectedDate.getDay())
    return new Date(this.currentDate.getFullYear() - 1, this.currentDate.getMonth(), selectedDate.getDate())
  }


  getFirstDayOfYear() {
    return new Date(this.currentDate.getFullYear(), 0, 1);
  }

  getFirstDayOfWeek(offset: number) {
    var selectedDate = this.getDate(offset * 7);
    return selectedDate.dateOffset(0 - selectedDate.getDay());
  }

  getLastDayOfWeek(offset: number) {
    var selectedDate = this.getDate(offset * 7);
    return selectedDate.dateOffset(7 - selectedDate.getDay());
  }

  dateRangePickerCallback(event: hwAny) {
    this.selectedDateFilter(event.startDate, event.endDate);
  }

  datePickerCallback(date: hwAny) {
    this.selectedDateFilter(date, date);
  }

  nextPrevDate(dateObj: hwAny) {
    this.selectedDate = dateObj.date;
    this.setDateFilterState(dateObj.date, dateObj.date)
    this.nextPrevDateCallback.emit({
      startDate: dateObj.date,
      endDate: dateObj.date
    })
  }

  enableAccept(event: Event, record: hwAny) {
    this.uiEventFilterMap.isApplyDisabled = false;
    this.uiEventFilterMap.isClearDisabled = false;
    this.uiMap.selectedKey = record.desc;
    this.uiMap.selectedOption = record.id;
  }
}

export class FNDateRangeConfig {
  startDate: Date;
  endDate: Date;
  maxDate: Date;
  isFutureDisabled: boolean = false;
  dateShowingFormat = '';
  dateValidationMsg = ''
  toBeShowen: Array<String>;
  maxDayNum: number;
}

export class OptionKey {
  id: string;
  desc: string;
}

export class DateFilterState {
  startDate: Date;
  endDate: Date;
  id: string;
}
